import Vue from 'vue'
import ItemHistory from './ItemHistory'
import http from 'utils/http'
import i18n from '@/locales'

let dataHistory = null
let dataIds = []
let vm = null

class SingletonDataHistory {
	/**
	 * первая инициализация данных (модальное окно истории изменений)
	 * @return {Promise}
	 */
	constructor (props) {
		let tradeItem = editableTradeItem

		dataHistory = http.post(`${window.urlContext}items/${props.itemId}/history/ids`, {})
			.then(function (res) {
				return http.post(`${window.urlContext}items/${props.itemId}/history/sort`, 'ids=' + JSON.stringify(res.data) + '&attr=version_number&asc=false', {
					headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
				}).then(function (res) {
					dataIds = res.data
					return http.post(`${window.urlContext}items/${props.itemId}/history/difference/load`, 'ids=' + JSON.stringify(res.data.slice(0, 10)), {
						headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
					}).then(function (res) {
						tradeItem.isSaved = false
						return res.data
					}).catch(function (error) {
						showMessageAlert('error', 'danger', error.response.data)
					})
				}).catch(function (error) {
					showMessageAlert('error', 'danger', error.response.data)
				})
			})
			.catch(function (error) {
				showMessageAlert('error', 'danger', error.response.data)
			})

		return dataHistory
	}
}

Vue.component('list-attribute', {
	data: function () {
		return {
			itemStructure: editableTradeItem.itemConfig,
			localization: editableTradeItem.localization
		}
	},
	template: '<ul class="checkbox-list"><li v-for="(value, key) in itemStructure" :key="key">' +
		' <input class="attribute-editor bg-editor" type="checkbox" :value="key">{{ $t(value.title) }}' +
		'</li></ul>'
})

const initItemHistory = function (props, elementId) {
	let dataArray

	if (editableTradeItem.isSaved || (dataHistory === null)) {
		dataArray = new SingletonDataHistory(props)
		vm = null
	} else {
		dataArray = dataHistory
	}

	dataArray.then((data) => {
		if (vm === null) {
			let ItemHist = Vue.extend(ItemHistory)
			vm = new ItemHist({i18n})
			vm.$mount(elementId)

			vm.$set(vm, 'historyList', data)
			vm.$set(vm, 'itemId', props.itemId)
			vm.$set(vm, 'currentPage', 1)
			vm.$set(vm, 'itemStructure', editableTradeItem.itemConfig)
			vm.$set(vm, 'localization', editableTradeItem.localization)
			vm.$set(vm, 'languages', Object.keys(editableTradeItem.language))
			vm.$set(vm, 'historyIds', dataIds)
		} else {
			props.modal.querySelector(elementId).appendChild(vm.$el)
		}

	}).catch(error => console.log(error))
}

export default initItemHistory
